import React from 'react'
import {
  LayoutDashboard, FileText, FolderOpen, Tag, Image,
  BarChart3, ExternalLink,
} from 'lucide-react'
import { NavItem } from '@/components/admin/molecules/navigation/NavItem'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { SidebarShell } from '@/components/admin/atoms/layout/SidebarShell'
import { SidebarSection } from '@/components/admin/atoms/layout/SidebarSection'
import { Avatar } from '@/components/admin/atoms/feedback/Avatar'
import { Text } from '@/components/admin/atoms/typography/Text'
import { SidebarLink } from '@/components/admin/atoms/navigation/SidebarLink'
import { ExternalNavLink } from '@/components/admin/atoms/navigation/ExternalNavLink'
import { IconSlot } from '@/components/admin/atoms/layout/IconSlot'
import { useSidebarVM } from './Sidebar.vm'

const iconStyle = { width: 20, height: 20 }

const NAV_ITEMS = [
  { href: '/admin', label: 'Dashboard', icon: <LayoutDashboard style={iconStyle} /> },
  { href: '/admin/posts', label: 'Posts', icon: <FileText style={iconStyle} /> },
  { href: '/admin/categories', label: 'Categories', icon: <FolderOpen style={iconStyle} /> },
  { href: '/admin/tags', label: 'Tags', icon: <Tag style={iconStyle} /> },
  { href: '/admin/media', label: 'Media', icon: <Image style={iconStyle} /> },
  { href: '/admin/analytics', label: 'Analytics', icon: <BarChart3 style={iconStyle} /> },
]

interface SidebarProps {
  open?: boolean
  className?: never
}

export const Sidebar: React.FC<SidebarProps> = ({ open = false }) => {
  const vm = useSidebarVM()

  return (
    <SidebarShell open={open}>
      <SidebarSection variant="header">
        <SidebarLink href="/admin">
          <Avatar initials="C" size="sm" shape="rounded" />
          <Stack gap="0" align="start">
            <Text size="sm" weight="bold" color="default">CodeOfMario</Text>
            <Text size="xs" color="muted">Admin</Text>
          </Stack>
        </SidebarLink>
      </SidebarSection>

      <SidebarSection variant="nav">
        <Stack gap="1">
          {NAV_ITEMS.map((item) => (
            <NavItem
              key={item.href}
              href={item.href}
              icon={item.icon}
              label={item.label}
              active={vm.isActive(item.href)}
            />
          ))}
        </Stack>
      </SidebarSection>

      <SidebarSection variant="footer">
        <ExternalNavLink href="/">
          <IconSlot><ExternalLink style={iconStyle} /></IconSlot>
          Visit Website
        </ExternalNavLink>
      </SidebarSection>
    </SidebarShell>
  )
}
